<script>/* eslint-disable */</script>
<template>
  <div style="height:400px" ref="SalesStock"></div>
</template>

<script>

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import animated from "@amcharts/amcharts4/themes/animated.js";

import moment from 'moment'

am4core.useTheme(animated);

export default {
  data(){
    return {
      chart: null,
      valueAxis : null
    }
  },
  mounted(){
    this.createChart();
    this.loadData()
  },
  beforeDestroy(){
    this.chart.dispose()
  },
  props: ['data'],
  watch : {
    type: function() {
      this.loadData()
    },
    week : {
      deep : true,
      handler : function () {
        this.loadData()
      }
    }
  },
  methods: {
    loadData () {

      this.chart.dispose()

      this.createChart()
      let length = this.chart.data.length

      let data = this.data
	// let data = [{"date":"2021-09-01","sales":20,"intransit_ahm_md":0.1,"stock_maindealer":0.3,"stock_dealer":4,"ahm_distribution":7},{"date":"2021-09-02","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-03","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-04","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-05","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-06","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-07","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-08","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-09","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-10","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-11","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-12","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-13","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-14","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-15","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-16","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-17","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-18","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-19","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-20","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-21","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-22","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-23","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-24","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-25","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-26","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-27","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-28","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-29","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-09-30","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-01","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-02","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-03","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-04","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-05","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-06","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-07","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-08","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-09","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-10","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0},{"date":"2021-10-11","sales":0,"intransit_ahm_md":0,"stock_maindealer":0,"stock_dealer":0,"ahm_distribution":0}]
      
      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = 'sales'
      series.dataFields.dateX = 'date'
      series.name = 'Sales'
      series.yAxis = this.valueAxis2
      series.tooltipText = `{name} {dateX}: [bold]{valueY}[/]`;

      
    
      //DATA PROCESSING STARTS

      let keys = Object.keys(data[0] ? data[0] : {})
      for(var i = 0 ; i < keys.length ; i++) {
        if(keys[i] == 'date' || keys[i] == 'sales')
          continue

        this.createAxisAndSeries(keys[i], this.toCapitalizedWords(keys[i]), false, i % 3);
      }

      this.chart.addData(data, length)
      
    },
    createChart () {
      this.chart = am4core.create(this.$refs.SalesStock, am4charts.XYChart);
      
      // this.chart.colors.step = 4;

      // Create axes
    //   let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    //   dateAxis.renderer.minGridDistance = 50;
    //   dateAxis.title.text = "Stock Days"
      let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis())
      dateAxis.title.text = "Date"

      this.chart.colors.list = [
        am4core.color("#FFC75F"),
        am4core.color("#D65DB1"),
        am4core.color("#FF6F91"),
        am4core.color("#FCBA12"),
        am4core.color('#808000'),
        am4core.color('#00FFFF')
      ];

      // Create series
      this.valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      this.valueAxis.title.text = "No. of Stock (Line Chart)"
      this.valueAxis.min = 0;

      this.valueAxis2 = this.chart.yAxes.push(new am4charts.ValueAxis());
      this.valueAxis2.title.text = "No. of Stock Days (Bar Chart)"
      this.valueAxis2.min = 0;
      this.valueAxis2.renderer.opposite = true;

      // Add legend
      this.chart.legend = new am4charts.Legend();

      

    //   this.chart.exporting.menu = new am4core.ExportMenu();

      // Add cursor
      this.chart.cursor = new am4charts.XYCursor();
    },
    createAxisAndSeries(field, name, opposite, bullet) {
      // console.log(field)
        
        let series = this.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.strokeWidth = 2;
        series.name = name;
        series.yAxis = this.valueAxis
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.showOnInit = true;
        
        let interfaceColors = new am4core.InterfaceColorSet();
        
        switch(bullet) {
          case 0:
            let bullet = series.bullets.push(new am4charts.Bullet());
            bullet.width = 12;
            bullet.height = 12;
            bullet.horizontalCenter = "middle";
            bullet.verticalCenter = "middle";
            
            let triangle = bullet.createChild(am4core.Triangle);
            triangle.stroke = interfaceColors.getFor("background");
            triangle.strokeWidth = 2;
            triangle.direction = "top";
            triangle.width = 12;
            triangle.height = 12;
            break;
          case 1:
            let bullet1 = series.bullets.push(new am4charts.Bullet());
            bullet1.width = 10;
            bullet1.height = 10;
            bullet1.horizontalCenter = "middle";
            bullet1.verticalCenter = "middle";
            
            let rectangle = bullet1.createChild(am4core.Rectangle);
            rectangle.stroke = interfaceColors.getFor("background");
            rectangle.strokeWidth = 2;
            rectangle.width = 10;
            rectangle.height = 10;
            break;
          default:
            let bullet2 = series.bullets.push(new am4charts.CircleBullet());
            bullet2.circle.stroke = interfaceColors.getFor("background");
            bullet2.circle.strokeWidth = 2;
            break;
        }
        
        this.valueAxis.renderer.line.strokeOpacity = 1;
        this.valueAxis.renderer.line.strokeWidth = 2;
        this.valueAxis.renderer.line.stroke = series.stroke;
        this.valueAxis.renderer.labels.template.fill = series.stroke;
        this.valueAxis.renderer.opposite = opposite;
      }
  }
}
</script>